module.exports = __webpack_public_path__ + "img/4_5.6cf8149f.png";